@import "../../styles/mixin.scss";
@import "../../styles/variables.scss";

.team-detail {
  background-color: #fff;
  padding: 32px;
}
